import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';

import arrowLeftImg from '../../images/icons/arrow-left.svg';
import menuLightIcon from '../../images/icons/icon-menu-light.svg';
import homeIcon from '../../images/icons/icon-is-home-light.svg';
import startAppIcon from '../../images/icons/icon-hub-start-app-3.svg';
import finishAppIcon from '../../images/icons/icon-finish-app-light.svg';
import viewQuotesIcon from '../../images/icons/icon-quotes-light.svg';
import viewPolicesIcon from '../../images/icons/icon-view-policy-light.svg';
import toolsIcon from '../../images/icons/icon-reference-tools-light.svg';
import contactUsIcon from '../../images/icons/icon-contact-us-light.svg';
import manageUsersIcon from '../../images/icons/icon-manage-users-light.svg';
import UserDispatch from '../../contexts/userDispatch';

import style from './LeftSideNav.module.css';

const LeftSideNav = React.memo(() => {
  const [collapsed, setCollapsed] = useState(false);
  const [width, setNavWidth] = useState(250);
  const toggleCollapse = () => {
    setCollapsed(!collapsed);

    if (collapsed) {
      setNavWidth(250);
    } else {
      setNavWidth(65);
    }
  };

  const user = useContext(UserDispatch);

  return (
    <nav className={style.nav} style={{ flexBasis: `${width}px` }}>
      <header
        tabIndex="0"
        role="button"
        onClick={toggleCollapse}
        onKeyDown={() => {}}
      >
        {!collapsed && <span>TOOLS</span>}
        <img
          width="24"
          height="24"
          src={arrowLeftImg}
          alt="collapse"
          hidden={collapsed}
        />
        <img
          width="24"
          height="24"
          src={menuLightIcon}
          alt="expand"
          hidden={!collapsed}
        />
      </header>
      <section>
        <div style={{ overflowY: 'auto', height: 'calc(100vh - 120px)' }}>
          <ul className={style.menuItems}>
            <li>
              <Link
                to="/"
                className={style.menuItem}
                data-testid="global-sidenav-home-link"
              >
                <img alt="home" src={homeIcon} />
                {!collapsed && <span>Home</span>}
              </Link>
            </li>
            <li>
              <Link
                to="/start"
                data-testid="global-sidenav-start-application-link"
              >
                <img alt="start application" src={startAppIcon} />
                {!collapsed && <span>Start Application</span>}
              </Link>
            </li>
            <li>
              <Link
                to="/finish"
                data-testid="global-sidenav-finish-an-application-link"
              >
                <img alt="finish application" src={finishAppIcon} />
                {!collapsed && <span>Finish an Application</span>}
              </Link>
            </li>
            <li>
              <Link to="/quotes" data-testid="global-sidenav-view-quotes-link">
                <img alt="view quotes" src={viewQuotesIcon} />
                {!collapsed && <span>View Quotes</span>}
              </Link>
            </li>
            <li>
              <Link
                to="/policies"
                data-testid="global-sidenav-view-policies-link"
              >
                <img alt="view policies" src={viewPolicesIcon} />
                {!collapsed && <span>View Policies</span>}
              </Link>
            </li>
            <li>
              <Link
                to="/clients"
                data-testid="global-sidenav-view-clients-link"
              >
                <img alt="view clients" src={startAppIcon} />
                {!collapsed && <span>View Clients</span>}
              </Link>
            </li>
            <li className={style.subMenu}>{!collapsed && 'AGENT RESOURCES'}</li>
            <li>
              <Link
                to="/tools"
                data-testid="global-sidenav-reference-tools-link"
              >
                <img alt="reference tools" src={toolsIcon} />
                {!collapsed && <span>Reference Tools</span>}
              </Link>
            </li>
            <li>
              <Link
                to="/contact-us"
                data-testid="global-sidenav-contact-us-link"
              >
                <img alt="contact us" src={contactUsIcon} />
                {!collapsed && <span>Contact Us</span>}
              </Link>
            </li>
            {user.isAdmin && (
              <li>
                <Link
                  to="/users"
                  data-testid="global-sidenav-manage-users-link"
                >
                  <img alt="manage users" src={manageUsersIcon} />
                  {!collapsed && <span>Manage Users</span>}
                </Link>
              </li>
            )}
          </ul>
        </div>
      </section>
    </nav>
  );
});

export default LeftSideNav;
